var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.name)?_c('div',{staticClass:"fts-state",style:({'background-color': _vm.model.color})},[_c('div',[_vm._v(_vm._s(_vm.model.name))])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }